'use client'

import { useEffect } from 'react'

export default function AutoScroll({ searchParams }) {
  useEffect(() => {
    if (Object.values(searchParams).filter((v) => v !== '').length === 0) return

    const resultsElement = document.getElementById('results')
    resultsElement?.scrollIntoView({ behavior: 'smooth' })
  }, [searchParams])

  return null
}
